import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';
import { ProjectDetailContent } from './projects/ProjectDetailPanel';

export default function ProjectDetailPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialTab = searchParams.get('tab');

  const [selected, setSelected] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const reqRef = useRef(id);

  const fetchProject = useCallback(async () => {
    reqRef.current = id;
    setLoading(true);
    setNotFound(false);
    try {
      const r = await api.get(`/projects/${id}`);
      if (reqRef.current !== id) return;
      setSelected(r.data);
    } catch {
      if (reqRef.current === id) setNotFound(true);
    } finally {
      if (reqRef.current === id) setLoading(false);
    }
  }, [id]);

  useEffect(() => { fetchProject(); }, [fetchProject]);
  useEffect(() => { api.get('/users').then(r => setUsers(r.data)).catch(() => {}); }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24 text-muted-foreground animate-pulse" data-testid="project-detail-loading">
        Loading project...
      </div>
    );
  }

  if (notFound || !selected) {
    return (
      <div className="py-24 text-center space-y-4" data-testid="project-detail-not-found">
        <p className="text-muted-foreground">Project not found.</p>
        <Button variant="outline" onClick={() => navigate('/projects')} data-testid="project-not-found-back">Back to Projects</Button>
      </div>
    );
  }

  return (
    <ProjectDetailContent
      selected={selected}
      users={users}
      initialTab={initialTab}
      onRefresh={(data) => { if (data?.id === id) setSelected(data); }}
      onProjectsRefresh={() => {}}
      onBack={() => navigate('/projects')}
    />
  );
}
